module.exports = __webpack_public_path__ + "img/md-assessment-a.de112dfa.svg";